import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Message List Config"})
export class MessageListConfig {

	@Input({type: InputType.NUMBER, title: "Page Size"})
	public pageSize?: number;

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/MessageListConfig.ts